import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown as falAngleDown,
  faAngleUp as falAngleUp,
  faCheck as falCheck,
  faCheckCircle as falCheckCircle,
  faCommentAlt as falCommentAlt,
  faEmptySet as falEmptySet,
  faExternalLink as falExternalLink,
  faLongArrowDown as falLongArrowDown,
  faLongArrowRight as falLongArrowRight,
  faLongArrowUp as falLongArrowUp,
  faSignIn as falSignIn,
  faTimes as falTimes,
} from '@fortawesome/pro-light-svg-icons';
import {
  faExternalLink,
  faFileCheck,
  faFileExclamation,
  faFilePlus,
  faTruckArrowRight as farTruckArrowRight,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBiohazard as fasBiohazard,
  faBoltLightning as fasBoltLightning,
  faCircle as fasCircle,
  faCloudUpload as fasCloudUpload,
  faCompressArrowsAlt as fasCompressArrowsAlt,
  faExclamationTriangle as fasExclamationTriangle,
  faExpandArrowsAlt as fasExpandArrowsAlt,
  faExternalLink as fasExternalLink,
  faEye as fasEye,
  faFileAlt as fasFileAlt,
  faFire as fasFire,
  faGridRound as fasGridRound,
  faGripVertical as fasGripVertical,
  faList as fasList,
  faMapMarkedAlt as fasMapMarkedAlt,
  faMapMarker as fasMapMarker,
  faMapMarkerAlt as fasMapMarkerAlt,
  faMapMarkerCheck as faMapMarkerCheck,
  faPencil as fasPencil,
  faRadiation as fasRadiation,
  faRoad as fasRoad,
  faSignIn as fasSignIn,
  faTruck as fasTruck,
  faWeightHanging as fasWeightHanging,
} from '@fortawesome/pro-solid-svg-icons';
import { App } from 'vue';

import { FontAwesomeInstaller as RygenFontAwesomeInstaller } from '@rygen/rygen-ui/config/FontAwesomeInstaller';

export class FontAwesomeInstaller extends RygenFontAwesomeInstaller {
  install(app: App): void {
    super.install(app);

    library.add(
      // @ts-ignore
      faExternalLink,
      faFileCheck,
      faFileExclamation,
      faFilePlus,
      falAngleDown,
      falAngleUp,
      falCheck,
      falCheckCircle,
      falCommentAlt,
      falEmptySet,
      falExternalLink,
      falLongArrowDown,
      falLongArrowRight,
      falLongArrowUp,
      falSignIn,
      falTimes,
      faMapMarkerCheck,
      farTruckArrowRight,
      fasBiohazard,
      fasBoltLightning,
      fasCircle,
      fasCloudUpload,
      fasCompressArrowsAlt,
      fasExclamationTriangle,
      fasExpandArrowsAlt,
      fasExternalLink,
      fasEye,
      fasFileAlt,
      fasFire,
      fasGridRound,
      fasGripVertical,
      fasList,
      fasMapMarkedAlt,
      fasMapMarker,
      fasMapMarkerAlt,
      fasPencil,
      fasRadiation,
      fasRoad,
      fasSignIn,
      fasTruck,
      fasWeightHanging,
    );
  }
}

export const fontAwesome = new FontAwesomeInstaller();
